export enum Icons {
  logo = "airaLogo",
  selectedBG = "selectedSideIconBG",
  userProfile = "logout_red",
  checkCircle = "checkCircle",
  closeCircle = "closeCircle",
  patientListIcon = "sidebar/patientListSideBar",
  aboutPatientIcon = "sidebar/aboutPatientSideBar",
  patientImagesIcon = "sidebar/patientImagesSideBar",
  uploadArrow = 'uploadIcon',
  usersIcon = "sidebar/users",
  reportsIcon = "sidebar/reportsSideBar",
  configureIcon = "sidebar/config_trail",
  eyeCheck = "eye-check",
  imgIcon = "img",
  viewReportIcon = "file-sync-outline",
  galleryItemPreviewIcon = "preview",
  galleryItemMalignantIcon = "malignant",
  galleryItemBeignalIcon = "beignal",
  galleryItemReviewedIcon = "reviewed",
  galleryItemNotReviewedIcon = "not_reviewed",
  galleryItemRejectedImageIcon = "img_reject",
  macroPreviewIcon = 'Macro',
  labelPreviewIcon = 'Label',
  thumbnailPreviewIcon = 'Thumbnail',
  roiPreviewIcon = 'ROI',
  selectedmacroPreviewIcon = 'selectedMacro',
  selectedlabelPreviewIcon = 'selectedLabel',
  selectedthumbnailPreviewIcon = 'selectedThumbnail',
  selectedroiPreviewIcon = 'selectedROI',
}